<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">Near Miss</h1>
  <p class="form-desc"></p>
</div>
<br>

  <mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
    <mat-card-content>
      <form [formGroup]="form" appSubmitDiag="nearmiss" (ngSubmit)="create()">
        <br>
          <mat-form-field appearance="fill">
            <mat-label>Date of Report:</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dateOfReport" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Project Supervisor:</mat-label>
            <input matInput formControlName="supervisor" placeholder="Enter project supervisor" required>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Office:</mat-label>
            <mat-select formControlName="office" required>
              @for (office of offices; track office.value) {
                <mat-option [value]="office.value">{{ office.label }}</mat-option>
              }
            </mat-select>
            <mat-error>This field is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Date of Near Miss:</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="nearMissDate" required>
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Time of Near Miss:</mat-label>
            <input matInput [matTimepicker]="timePicker" formControlName="time" required>
            <mat-timepicker-toggle matIconSuffix [for]="timePicker"/>
            <mat-timepicker #timePicker/>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Location of Incident/Near Miss:</mat-label>
            <input matInput formControlName="location" placeholder="Enter location" required>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Type of Incident/Near Miss: (Driving, Lifting, Fall, Slip etc.):</mat-label>
            <input matInput formControlName="type" placeholder="Enter type of Near Miss" required>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Company Equipment/Vehicles/Tools Involved:</mat-label>
            <input matInput formControlName="equipment" placeholder="Enter items involved" required>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Company Personnel Involved (Optional):</mat-label>
            <input matInput formControlName="persons" placeholder="Enter personnel involved">
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Details of Incident/Near Miss:</mat-label>
            <input matInput formControlName="desc" placeholder="Enter details" required>
          </mat-form-field>
          <br>
            <mat-label class="qTitle">Rate the potential for serious injury (Required):</mat-label>
            <br><br>
            <mat-radio-group formControlName="rate" name="rate">
              <mat-radio-button value="low">Low</mat-radio-button>
              <mat-radio-button value="moderate">Moderate</mat-radio-button>
              <mat-radio-button value="high">High</mat-radio-button>
            </mat-radio-group>
            <br>

              <mat-form-field appearance="fill">
                <mat-label>Corrective Actions/Steps Taken:</mat-label>
                <input matInput formControlName="actions" placeholder="Enter actions/steps taken" required>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Date Incident/Near Miss was discussed with crew:</mat-label>
                <input matInput formControlName="dateDiscussed" [matDatepicker]="picker3" required>
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
              </mat-form-field>

              <mat-label class="note">You may opt to submit this form anonymously by not answering the following questions. By including your email/full name in the following questions, the form submission will not be anonymous. Landpoint recognises and appreciates employee who submit Near Miss forms.</mat-label>
              <br><br>
              <mat-form-field appearance="fill">
                <mat-label>Report Completed By:</mat-label>
                <input matInput formControlName="completedBy" placeholder="Enter name">
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Job Title:</mat-label>
                <input matInput formControlName="title" placeholder="Enter job title">
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Email:</mat-label>
                <input matInput formControlName="email" placeholder="Enter email/name">
              </mat-form-field>

              <div class="button-container">
                <button mat-raised-button color="primary" class="submit-button" [disabled]="isSubmitting">{{ isSubmitting ? 'Submitting…' : 'Submit' }}</button>
              </div>

              @if (isSubmitting) {
                <div class="custom-spinner-container">
                  <div class="custom-spinner"></div>
                </div>
              }

              @if (!isSubmitting && form.invalid && form.touched) {
                <div class="error-message">
                  Please fill in all required fields.
                </div>
              }

              @if (warningMessage) {
                <div class="error-message">{{ warningMessage }}</div>
              }

            </form>
          </mat-card-content>
        </mat-card>

        <br><br>

        <div class="page-title">
          <p class="form-desc-two">If form does not submit, ensure all required fields are answered. Additionally, depending on the network, the form submission may take a minute. If it still does not submit, reach out directly to <i class="contact">(pturner&#64;landpoint.net)</i> to get it handled. </p>
        </div>
